"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
function useForceUpdate() {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var _a = react_1.useReducer(function (x, _) { return x + 1; }, 0), forceUpdate = _a[1];
    return forceUpdate;
}
exports.default = useForceUpdate;
//# sourceMappingURL=forceUpdate.js.map